<template>
	<div class="country_selector country_selector_new countrypos LangbeforeLogin" >
		<div class="country_selector_btn_wrapper" @click.prevent="lang_hideShow = !lang_hideShow" > 
			<span class="country_selector_flag " :class="flagico"></span>
			<span class="country_selector_name">{{json[langtext]}}</span>
		</div>
		<div class="country_selector_list-wrapper language" v-if="lang_hideShow" @click.prevent="lang_hideShow =  lang_hideShow"  >
			<ul class="country_dropdown scrollbar">
				<li @click.prevent="changeLocale('en', 'English', 'flag-eng')"  class="country_dropdown_list_item"> 
					<span class="country_selector_flag flag-eng"></span>
					<span class="country_dropdown_link_name">English</span> 
				</li> 
				<li @click.prevent="changeLocale('es', 'Spanish', 'flag-spa')"   class="country_dropdown_list_item">
					<span class="country_selector_flag flag-spa"></span>
					<span class="country_dropdown_link_name">Español</span> 
				</li> 
				<li @click.prevent="changeLocale('ar', 'Arabic', 'flag-arb')"   class="country_dropdown_list_item">
					<span class="country_selector_flag flag-arb"></span>
					<span class="country_dropdown_link_name">عربي</span> 
				</li> 
				<li @click.prevent="changeLocale('zh', 'Chinese', 'flag-chi')"   class="country_dropdown_list_item">
					<span class="country_selector_flag flag-chi"></span>
					<span class="country_dropdown_link_name">中国人</span> 
				</li>  
				<li @click.prevent="changeLocale('pt', 'Portuguese', 'flag-pt')"   class="country_dropdown_list_item">
					<span class="country_selector_flag flag-pt"></span>
					<span class="country_dropdown_link_name">Português</span> 
				</li> 
				<li @click.prevent="changeLocale('id', 'Indonesia', 'flag-id')"   class="country_dropdown_list_item">
					<span class="country_selector_flag flag-id"></span>
					<span class="country_dropdown_link_name">Indonesia</span> 
				</li> 
				<!-- <li @click.prevent="changeLocale('ge', 'germany', 'flag-ger')"  class="country_dropdown_list_item"> 
					<span class="country_selector_flag flag-ger"></span>
					<span class="country_dropdown_link_name">Deutsch</span> 
				</li> 
            				<li @click.prevent="changeLocale('it', 'itly', 'flag-itly')"   class="country_dropdown_list_item">
					<span class="country_selector_flag flag-itly"></span>
					<span class="country_dropdown_link_name">Italiano</span> 
				</li> 
				<li @click.prevent="changeLocale('fr', 'french', 'flag-french')"   class="country_dropdown_list_item">
					<span class="country_selector_flag flag-french"></span>
					<span class="country_dropdown_link_name">Français</span> 
				</li>
				<li @click.prevent="changeLocale('gr', 'greek', 'flag-greek')"   class="country_dropdown_list_item">
					<span class="country_selector_flag flag-greek"></span>
					<span class="country_dropdown_link_name">Ελληνικά</span> 
				</li>		 -->		
			</ul>
		</div> 
	</div>
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    import i18n from '@/plugins/lang/i18n';
    export default {
        name: 'Login',
        mixins: [fxViewMixins],
        data() {
            return {
                lang_hideShow: false,
				langtext: 'English',
				flagico: 'flag-eng',
				json : {
					'greek' : 'Ελληνικά',
					'french' : 'Français',
					'itly': 'Italiano',
					'germany': 'Deutsch',
					'Spanish' :'Español',
					'English' :'English',
					'Arabic' :'عربي',
					'Chinese' :'中国人',
					'Portuguese' :'Português',
					'Indonesia' :'Indonesia'
				}
            }
        },
		props:['page'],
        methods:{
            changeLocale(locale, lang, flagicon) {
                this.langtext= lang;
                this.flagico= "flag "+flagicon;
                i18n.locale = locale; 
				this.lang_hideShow = false	
				let input_json={
					'globalParams' :{'lang' : this.langtext},
					'localParams' :{ "parameter" : this  ,'page' : this.page}
				}
				this._runLanguageApi(input_json)
            }
        },
		mounted() {
			const _that = this
			$(document).on('click', function (event) {
				if (!$(event.target).closest('.language').length && !$(event.target).closest('.country_selector_btn_wrapper').length) {
					_that.lang_hideShow = false
				}
			});
		},
		created(){

			if(localStorage.getItem('lang')){
				this.langtext = localStorage.getItem('lang')
				if(localStorage.getItem('lang') == 'Spanish'){
					this.flagico = 'flag-spa'
					i18n.locale = 'es'; 
				}else if(localStorage.getItem('lang') == 'English'){
					this.flagico = 'flag-eng'
					i18n.locale = 'en'; 
				}else if(localStorage.getItem('lang') == 'Arabic'){
					this.flagico = 'flag-arb'
					i18n.locale = 'ar'; 
				}else if(localStorage.getItem('lang') == 'Chinese'){
					this.flagico = 'flag-chi'
					i18n.locale = 'zh'; 
				}else if(localStorage.getItem('lang') == 'Portuguese'){
					this.flagico = 'flag-pt'
					i18n.locale = 'pt'; 
				}else if(localStorage.getItem('lang') == 'Indonesia'){
					this.flagico = 'flag-id'
					i18n.locale = 'id'; 
				}/*else if(localStorage.getItem('lang') == 'germany'){
					this.flagico = 'flag-ger'
					i18n.locale = 'ge'; 
				}else if(localStorage.getItem('lang') == 'french'){
					this.flagico = 'flag-french'
					i18n.locale = 'fr'; 
				}else if(localStorage.getItem('lang') == 'greek'){
					this.flagico = 'flag-greek'
					i18n.locale = 'gr'; 
				}else{
					this.flagico = 'flag-itly'
					i18n.locale = 'it'; 
				}*/
			}else{
				this.langtext = 'English'
				this.flagico = 'flag-eng' 
				i18n.locale = 'en'; 
				// let userLang = navigator.language || navigator.userLanguage;
				// userLang = userLang.split("-")[0].toLowerCase()
				// if(userLang == 'en' || userLang == 'it' || userLang == 'el' || userLang == 'de' || userLang == 'fr' || userLang == 'es'){
				// 	if(userLang == 'it'){
				// 		this.langtext = 'itly'
				// 		this.flagico = 'flag-itly'
				// 		i18n.locale = 'it'; 
				// 	}else if(userLang == 'de'){
				// 		this.langtext = 'germany'
				// 		this.flagico = 'flag-ger'
				// 		i18n.locale = 'ge'; 
				// 	}else if(userLang == 'el'){
				// 		this.langtext = 'greek'
				// 		this.flagico = 'flag-greek'
				// 		i18n.locale = 'gr'; 
				// 	}else if(userLang == 'fr'){
				// 		this.langtext = 'french'
				// 		this.flagico = 'flag-french' 
				// 		i18n.locale = 'fr'; 
				// 	}else if(userLang == 'es'){
				// 		this.langtext = 'Spanish'
				// 		this.flagico = 'flag-spa' 
				// 		i18n.locale = 'es'; 
				// 	}else {
				// 		this.langtext = 'English'
				// 		this.flagico = 'flag-eng'
				// 		i18n.locale = 'en'; 
				// 	}
				// }else {
				// 	this.langtext = 'English'
				// 	this.flagico = 'flag-eng' 
				// 	i18n.locale = 'en'; 
				// }
			}
		}
    }
</script>	
		



// WEBPACK FOOTER //
// src/components/fxView/shared/language_before_login.vue